<template>
  <div class="v18-creator v17-column v17-tab">
    <div class="inner-shadow" v-show="!currentKey"></div>

    <f-creator-tabs
      :component="component"
      :handler="handler"
      :current-project="currentKey"
      @change="show($event)"
    ></f-creator-tabs>

    <div class="content" :class="{ 'add-source': !currentKey }">
      <vue-placeholder
        :component="currentKey ? component.projects[currentKey].component : null"
        :handler="handler"
      ></vue-placeholder>

      <div class="v17-column add-source" v-show="!currentKey">
        <div class="v18-vcreator-source">
          <div class="v18-vcreator-source-container">
            <f-creator-source-list
              :title="component.title"
              :subtitle="component.subtitle"
              :overlimits-message="component.overlimit_message"
              :sources="component.templates"
              :handler="handler"
              :is-overlimits="isOverlimits"
              @oncreate="sourceCreated($event.key)"
            ></f-creator-source-list>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FCreatorTabs from './FCreatorTabs.vue'
import FCreatorSourceList from './FCreatorSourceList.vue'

export default {
  translate25Context: 'vcreator18',
  components: { FCreatorTabs, FCreatorSourceList },
  props: {
    component: Object,
    handler: Object,
  },
  data() {
    return {
      currentKey: null,
      overlimits: [],
      limits: undefined,
    }
  },
  computed: {
    isOverlimits() {
      return !!(this.overlimits && this.overlimits.length > 0)
    },
    sortedProjects() {
      if (!this.component.projects) return []
      return Object.values(this.component.projects).slice().sort((a, b) => {
        return (a.weight || 0) - (b.weight || 0)
      })
    },
  },
  watch: {
    'component.limits_by_class': {
      immediate: true,
      handler(limitsByClass) {
        this.parseLimits(limitsByClass, this.component.limits)
      },
    },
    'component.limits': {
      handler(globalLimits) {
        this.parseLimits(this.component.limits_by_class, globalLimits)
      },
    },
    'component.projects': {
      immediate: true,
      deep: false,
      handler(newProjects) {
        this.updateLimits(newProjects, this.limits)

        if (!newProjects) {
          this.currentKey = null
          return
        }

        const sorted = Object.entries(newProjects)
          .map(([key, project]) => ({ _key: key, weight: project.weight }))
          .sort((a, b) => (a.weight || 0) - (b.weight || 0))

        if (this.currentKey === null) {
          this.currentKey = sorted.length > 0 ? sorted[0]._key : null
          return
        }

        if (!newProjects[this.currentKey]) {
          this.currentKey = sorted.length > 0 ? sorted[0]._key : null
        }
      },
    },
  },
  methods: {
    show(key) {
      this.currentKey = key
    },
    sourceCreated(key) {
      this.currentKey = key
    },
    parseLimits(limitsByClass, globalLimits) {
      let limits
      if (limitsByClass) {
        limits = JSON.parse(limitsByClass)
      } else if (globalLimits) {
        limits = JSON.parse(globalLimits)
      } else {
        limits = undefined
      }
      this.limits = limits
      this.updateLimits(this.component.projects, limits)
    },
    updateLimits(projects, limits) {
      if (!projects || !limits) {
        this.overlimits = []
        return
      }

      const projectCountByClass = {}

      Object.values(projects).forEach((project) => {
        const projectClasses = (project.class || 'default').split(/[\s,]+/)
        projectClasses.forEach((projectClass) => {
          projectCountByClass[projectClass] = (projectCountByClass[projectClass] || 0) + 1
        })
        projectCountByClass['total'] = (projectCountByClass['total'] || 0) + 1
      })

      if (typeof limits === 'number') {
        if (projectCountByClass.total >= limits) {
          this.overlimits = [['', limits]]
        } else {
          this.overlimits = []
        }
        return
      }

      this.overlimits = Object.entries(projectCountByClass).filter(([key, count]) => {
        return limits[key] !== undefined && count >= limits[key]
      })
    },
  },
}
</script>
